module.exports = __webpack_public_path__ + "media/images/front/img_makers_etac-6627ecd1d99536c3ebedb685b0bf0577.jpg";